import { QueryKeyConfig, MutationKeyConfig } from './api-helper';

export interface NoteListRequestArgs {
  projectID?: number;
  officeID?: number;
  customerID?: number;
  workOrderID?: number;
  unitID?: number;
  noteTempEntityID?: number;
  planReviewTaskID?: number;
  noteType?: string;
}

const getNoteQueryStrings = (args: NoteListRequestArgs) => {
  const params = new URLSearchParams();
  if (args.customerID) params.append('customerID', String(args.customerID));
  if (args.officeID) params.append('officeID', String(args.officeID));
  if (args.projectID) params.append('projectID', String(args.projectID));
  if (args.unitID) params.append('unitID', String(args.unitID));
  if (args.workOrderID) params.append('WorkOrderID', String(args.workOrderID));
  if (args.planReviewTaskID) params.append('planReviewTaskID', String(args.planReviewTaskID));
  if (args.noteTempEntityID) params.append('noteTempEntityID', String(args.noteTempEntityID));
  if (args.noteType) params.append('noteType', args.noteType);
  return params.toString();
};

export const noteApiKeyStore = {
  createNote: (): MutationKeyConfig => ({
    mutationKey: [`CREATE_NOTE`],
    route: `/Note`,
    action: 'POST',
  }),
  updateNote: (): MutationKeyConfig => ({
    mutationKey: [`UPDATE_NOTE`],
    route: `/Note`,
    action: 'PUT',
  }),
  deleteNote: (id: number): MutationKeyConfig => ({
    mutationKey: [`DELETE_NOTE`, id],
    route: `/Note/${id}`,
    action: 'DELETE',
  }),
  getNotes: (args: NoteListRequestArgs): QueryKeyConfig => ({
    queryKey: [
      `GET_NOTES`,
      ...[args.customerID, args.noteTempEntityID, args.officeID, args.projectID, args.unitID, args.workOrderID, args.planReviewTaskID, args.noteType].filter(
        (a) => a
      ),
    ],
    route: `/Note?${getNoteQueryStrings(args)}`,
    isEnabled:
      !!args &&
      (!!args.customerID ||
        !!args.officeID ||
        !!args.projectID ||
        !!args.noteTempEntityID ||
        !!args.unitID ||
        !!args.workOrderID ||
        !!args.planReviewTaskID),
  }),
};
